import { generatePath, matchPath } from "react-router-dom";
import type { AppLocale } from "@akina/infra";
import { AppRoutes } from ".";

// The camera session is the only screen that cannot work on small viewports;
// everything else (incl. subscription management) must stay reachable on mobile.
export const isMobileBlockedRoute = (pathname: string): boolean =>
  matchPath(AppRoutes.NextSession, pathname) !== null;

export const LOCALE_GET_PARAM = "locale";

//refresh=1 is added to trigger a store refresh in the session page
export const getNextSessionRoute = (treatmentId: string) =>
  `${generatePath(AppRoutes.NextSession, { treatmentId })}?refresh=1`;

export const getUrlWithLocale = (route: AppRoutes, locale: AppLocale) => `${route}?${LOCALE_GET_PARAM}=${locale}`;
